/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useRef, useEffect, useCallback } from 'react';
import { Avatar, Theme } from '@mui/material';
import {
  CcfButton,
  CcfSeeMoreIcon,
  CcfTwitterAuthBatchIcon,
  CcfTwitterCommentsIcon,
  CcfTwitterFavoriteIcon,
  CcfTwitterInsertEmojiIcon,
  CcfTwitterInsertGifIcon,
  CcfTwitterInsertPicIcon,
  CcfTwitterRetweetIcon,
  CcfQuickRepliesIcon,
  CcfTypography,
  CcfFacebookLikeIcon,
  CcfFacebookLoveIcon,
  CcfFacebookWowIcon,
  CcfAddNotesIcon,
  CcfCoBrowseIcon,
  CcfTooltip,
  CcfFlashIcon,
  useTranslator,
} from '@nice-ccf/ui-controls';
import {
  getInteractionTabs,
  getActiveInteractionID,
  updateAppSpaceTab,
  updateTwitterAgentReply,
  activeContactSelector,
  getJsonFileUploadStatus,
  setJsonFileUploadStatus,
  getEnlightenTabFeatureToggle,
  getActiveInteractionType,
  getCustomerChatReplyJsonData,
  getContactElevationDetails,
  getContactBotTranscriptSelector,
  setIsChatEnded,
  getIsCopilotEmailResponseGenerated,
} from '../../ccf-inbox/ccf-inbox.slice';
//import {customerChatInputReplyState } from '../../../../../../../apps/cxone-agent-demo/src/simulator/simulator.slice';
import { useDispatch, useSelector } from 'react-redux';
import CcfDigitalMessageCard from './ccf-digital-message-card';
import { Contact } from '../../ccf-inbox/model/contact';
import {
  getSentQReply,
  updateSentQReply,
} from '../../ccf-app-space/ccf-app-space.slice';
import {
  CcfTextEditor,
  getRtigSuggestionCardName,
  getInteractionMsgCount,
  globalActions,
  interactionSliceActions,
  getContactSentiment,
  getEmailHistoryDetails,
  CcfCopilotVideoCall,
  CcfCopilotReimbursementClaimForm,
  CcfCopilotChatSuggestionCard,
  getCopilotConfig,
  getApplicationLocale,
} from '@nice-ccf/ui-components';
import { AppSpace } from '../../../enums/app-space-tabs';
import {
  DigitalChannelStatus,
  DigitalChannelType,
  fomatToDateString,
  fomatToTimeString,
  InteractionTabType,
  MediaType,
  VoiceContactStatus,
} from '@nice-ccf/core-sdk';
import { Send } from '@mui/icons-material';
import styles from './ccf-digital-contact-body.module.scss';
import CcfDigitalEmailCard from './ccf-digital-email-card';
import CcfLiveDigitalEmailCard from './ccf-live-digital-email-card';
import CcfChatBox from '../../ccf-interaction-tabs/ccf-chat-box/ccf-chat-box';
import { createStyles, makeStyles } from '@mui/styles';
import { processApiResponse } from '../../ccf-app-space/ccf-copilot/ccf-copilot-util';
import {
  API_BASE_URL,
  ApiResponse,
  callApi,
  PROCESS_UTTERANCE,
} from '../../ccf-app-space/ccf-copilot/ccf-copilot-api';
import {
  getIsRequestProcessing,
  setIsRequestProcessing,
} from '../../ccf-app-space/ccf-copilot/ccf-copilot-chat/+state/ccf-live-copilot.slice';
import { v5 as uuidv5, NIL as namespaceNIL } from 'uuid';
import { useMsal } from '@azure/msal-react';

//import { copilotAgentAndCustomerChatData } from '../../ccf-app-space/ccf-copilot/mock-data/ccf-copilot-agentandcustomer-chat-mock-data';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    actionButton: {
      marginRight: theme.spacing(1),
    },
    marginRight24: {
      '& > span': {
        marginRight: theme.spacing(3) + 'px !important',
      },
    },
    replyCard: {},
  })
);

export interface replyMessagesType {
  id?: string;
  tweetId: string;
  name?: string;
  authorUser?: any;
  createdAt: Date;
  messageContent: { [messageContent: string]: { [payload: string]: string } };
  reactionStatistics: { [key: string]: string };
  isOwn: boolean;
  messageId: string;
}
/* eslint-disable-next-line */
export interface CcfInteractionBodyProps {
  selectedCallContact: Contact;
}

/**
 * Component used to twitter interaction
 * @param props - CcfInteractionBodyProps
 * @example <CcfInteractionBody />
 * @returns
 */
export function CcfInteractionBody(props: CcfInteractionBodyProps) {
  const classes = useStyles();
  const { accounts } = useMsal();
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const [showOriginalTweet, setShowOriginalTweet] = useState(false);
  const [showTweetReplies, setShowTweetReplies] = useState(false);
  const [showReplyBox, setShowReplyBox] = useState(false);
  const textareaRef = useRef<any>(null);
  const [textAreaValue, setTextAreaValue] = useState('');
  const dispatch = useDispatch();
  const quickReply = useSelector(getSentQReply);
  const interactionTabs = useSelector(getInteractionTabs) || {};
  const activeInteractionID: string = useSelector(getActiveInteractionID) || '';
  const activecontact = useSelector(activeContactSelector);
  const { setInteractionMsgCount, setCoBrowsingSessionClosed } =
    interactionSliceActions;
  const { setContactSentiment, setIsEditInlineNote } = globalActions;
  const sentimentData = useSelector(getContactSentiment);
  const interactionMSgCount = useSelector(getInteractionMsgCount);
  const userReplyChatData = activecontact?.customerChatReplyJsonData ?? [];
  const isChatJsonFileUploaded = useSelector(getJsonFileUploadStatus);
  const showEnlightenTab = useSelector(getEnlightenTabFeatureToggle);
  const activeInteractionType = useSelector(getActiveInteractionType);
  const emailDateData = useSelector(getEmailHistoryDetails);
  const contactElevatedDetails = useSelector(getContactElevationDetails);
  const [agentName, setAgentName] = useState('');
  const [translate] = useTranslator();
  const intents = activecontact?.intents ?? [];
  const customReplies = activecontact?.customReplies ?? [];
  const customerSentiment = activecontact?.customerSentiment ?? [];
  const copilotConfiguration: any = useSelector(getCopilotConfig);
  const [localConfiguration, setLocalConfiguration] =
    useState(copilotConfiguration);
  const locale = localConfiguration.language;
  const isCopilotEmailResponseGenerated = useSelector(
    getIsCopilotEmailResponseGenerated
  );
  const isRequestProcessing = useSelector(getIsRequestProcessing);
  const isCopilotSourceLiveLLM = activecontact?.copilotSource === 'Live LLM';

  let scrollToEndOfTranscript = false;
  let clickedAddNotes = false;
  let clickedCoBrowse = false;
  const selectedCallContactChannel =
    props.selectedCallContact.channel?.toLowerCase();
  const isEnabled =
    activecontact?.contactStatus === VoiceContactStatus.ACTIVE ||
    activecontact?.contactStatus === DigitalChannelStatus.OPEN;
  const {
    name: originalTweetId,
    otherReplies,
    originalTweetContent,
    agentReply,
    realExternalPlatformId,
    isHistoryEmailContent,
  } = interactionTabs[activeInteractionID];
  // const [chatMsgLength, setChatMsgLength] = useState(agentReply.length);
  const currentInteactionType = {
    facebook: false,
    instagram: false,
    twitter: false,
    email: false,
    chat: false,
    sms: false,
    CopilotChat: false,
    VideoCall: false,
    reimbursementClaim: false,
  };

  const suggestionCardHeader = useSelector(getRtigSuggestionCardName);
  const sentimentType = activecontact?.agentAssistStatus;
  // const copilotConfigurations = useSelector(getCopilotConfig);
  const copilotConfigurations = JSON.parse(localStorage.getItem('agentAssistAppConfig') as string) || {};
  const namespace = uuidv5('namespace', namespaceNIL);

  const requestBody = {
    // eslint-disable-next-line @typescript-eslint/no-loss-of-precision
    contactId: activecontact?.id,
    busNo: 12345678,
    tenantId: '12345678',
    participantId: '',
    messageBody: '',
    getSalesOffers: false,
    getCompliance: false,
    getConversationAssistance: false,
    getKbCombo: false,
    getProcessSteps: false,
    messageMetaData: {
      completeUtterance: true,
    },
    transcriptionEventId: '',
    threshold_sales: copilotConfigurations?.threshold_sales ?? 0.75,
    threshold_compliance: copilotConfigurations?.threshold_compliance ?? 0.75,
    agentAssistAppConfig: {
      language: locale.toLowerCase(),
      generativeResponseTone:
        copilotConfigurations?.generativeResponseTone ?? 'Formal',
      channels: ['digital', 'voice'],
      transcriptionProfileName: 'google-test',
      enableSentiment: copilotConfigurations?.enableSentiment ?? true,
      sentimentResponseLength:
        copilotConfigurations?.sentimentResponseLength ?? 20,
      realTimeSummary: copilotConfigurations?.realTimeSummary ?? true,
      realTimeSummaryResponseLength:
        copilotConfigurations?.realTimeSummaryResponseLength ?? 25,
      finalSummary: copilotConfigurations?.finalSummary ?? true,
      finalSummaryResponseLength:
        copilotConfigurations?.finalSummaryResponseLength ?? 65,
      behavioralGuidance: true,
      behavioralGuidanceResponseLength: 10,
      behevioralGuidanceNumberOfResponse: 3,
      enableExpertCopilotIntegration: true,
      expertCopilotURL: copilotConfigurations?.expertCopilotURL ?? '',
      expertCopilotClientKey:
        copilotConfigurations?.expertCopilotClientKey ?? '',
      expertCopilotClientSecret:
        copilotConfigurations?.expertCopilotClientSecret ?? '',
      path: copilotConfigurations?.path ?? '',
      botPersona: copilotConfigurations?.botPersona ?? '',
      kBAnswersPath: copilotConfigurations?.kBAnswersPath ?? '',
      salesOffersPath: copilotConfigurations?.salesOffersPath ?? '',
      compliancePath: copilotConfigurations?.compliancePath ?? '',
      nextBestResponse: copilotConfigurations?.nextBestResponse ?? true,
      nextBestResponseLength:
        copilotConfigurations?.nextBestResponseLength ?? 20,
      nextBestNumberOfResponse:
        copilotConfigurations?.nextBestNumberOfResponse ?? 2,
      knowledgeBaseArticles:
        copilotConfigurations?.knowledgeBaseArticles ?? true,
      knowledgeBaseArticlesResponseLength:
        copilotConfigurations?.knowledgeBaseArticlesResponseLength ?? 65,
      knowledgeBaseWebLinks:
        copilotConfigurations?.knowledgeBaseWebLinks ?? true,
      knowledgeBaseMaximumWebLinks:
        copilotConfigurations?.knowledgeBaseMaximumWebLinks ?? 3,
      knowledgeBaseImages: copilotConfigurations?.knowledgeBaseImages ?? true,
      knowledgeBaseMaximumImages:
        copilotConfigurations?.knowledgeBaseMaximumImages ?? 3,
      knowledgeBaseProcessSteps:
        copilotConfigurations?.knowledgeBaseProcessSteps ?? true,
      knowledgeBaseMaximumSteps:
        copilotConfigurations?.knowledgeBaseMaximumSteps ?? 10,
      threshold: copilotConfigurations?.threshold ?? 0.75,
      vendorId: 'agentCopilot',
      agentAssistId: 'Ved_acp_test123',
      scriptParams: '',
      backAndForthLiveConvo:
        copilotConfigurations?.backAndForthLiveConvo ?? false,
      backAndForthLiveConvoLength:
        copilotConfigurations?.backAndForthLiveConvoLength ?? 4,
    },
    messageIsCompletedUtterance: true,
    agentId: 1898,
    mediaType: activecontact?.media === 'Voice' ? 'Voice' : 'Digital',
    totalAudioChunksInMilliSeconds: 2040,
  };

  // const updateCopilotUserChatScreenSet: any = [];

  useEffect(() => {
    if (scrollToEndOfTranscript) {
      setTimeout(() => {
        document.getElementById('bodyContainer')?.scroll({
          top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
          behavior: 'smooth', //auto, smooth, initial, inherit
        });
      }, 1000);
    }
  }, [scrollToEndOfTranscript]);

  /**
   * Function to check interaction type
   * @param event -any
   * @example checkInteractionType
   */
  const checkInteractionType = () => {
    switch (realExternalPlatformId) {
      case 'fb':
        currentInteactionType.facebook = true;
        break;
      case 'ig':
        currentInteactionType.instagram = true;
        break;
      case 'tw':
        currentInteactionType.twitter = true;
        break;
      case 'email':
        currentInteactionType.email = true;
        break;
      case 'chat':
        currentInteactionType.chat = true;
        break;
      case 'sms':
        currentInteactionType.sms = true;
        break;
      case 'CopilotChat':
        currentInteactionType.CopilotChat = true;
        break;
      case 'VideoCall':
        currentInteactionType.VideoCall = true;
        break;
      case 'reimbursementClaim':
        currentInteactionType.reimbursementClaim = true;
        break;
      default:
        break;
    }
  };

  checkInteractionType();

  /**
   *
   */
  const shiftEnterFunction = useCallback(
    (e: any) => {
      if (
        e.key === 'Enter' &&
        e.shiftKey &&
        textAreaValue.replace(/\s/g, '').length
      ) {
        handleSendClick();
      }
    },
    [textAreaValue]
  );

  useEffect(() => {
    if (userReplyChatData.length) {
      setAgentName(userReplyChatData?.[0].agentName?.split(' ')?.[0]);
    }
  }, [userReplyChatData]);

  useEffect(() => {
    document.addEventListener('keydown', shiftEnterFunction, false);
    return () => {
      document.removeEventListener('keydown', shiftEnterFunction, false);
    };
  }, [shiftEnterFunction]);

  useEffect(() => {
    if (activecontact?.copilotSource !== 'Live LLM') {
      if (
        activecontact?.channel === 'Chat' &&
        activecontact?.copilotAssist === 'No'
      ) {
        let indexVal = 0;
        let fileUpload =
          activecontact?.customerChatReply?.length > 0 ? false : true;
        const loop = setInterval(() => {
          if (
            fileUpload &&
            isChatJsonFileUploaded &&
            indexVal < userReplyChatData.length
          ) {
            let userReply = '';
            if (
              userReplyChatData.length &&
              userReplyChatData[indexVal].messageFrom === 'customer'
            ) {
              userReply = userReplyChatData[indexVal].message[0];
            } else {
              userReply = userReplyChatData[indexVal].message[0];
            }
            const replyMessage = {
              messageId: new Date().toString(),
              postId:
                'chat_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
              isOwn: true,
              createdAt: formatMsgTime(locale),
              messageContent: {
                payload: {
                  text: userReply,
                },
              },
              reactionStatistics: {
                likes: 0,
              },
              authorUser: {
                firstName:
                  userReplyChatData[indexVal].messageFrom === 'bot'
                    ? 'Bot'
                    : userReplyChatData[indexVal].messageFrom === 'agent'
                    ? loginCredentialsArray[0].charAt(0).toUpperCase() +
                      loginCredentialsArray[0].slice(1).toLowerCase()
                    : activecontact?.customer?.firstName,
                surname:
                  userReplyChatData[indexVal].messageFrom === 'bot'
                    ? 'Reply'
                    : userReplyChatData[indexVal].messageFrom === 'agent'
                    ? loginCredentialsArray[1].charAt(0).toUpperCase() +
                      loginCredentialsArray[1].slice(1).toLowerCase()
                    : activecontact?.customer?.lastName,
                emailAddress:
                  userReplyChatData[indexVal].messageFrom === 'bot'
                    ? 'bot@nice.com'
                    : userReplyChatData[indexVal].messageFrom === 'agent'
                    ? 'customer.service@delta.com'
                    : activecontact?.customer?.emailId,
                loginUsername: activecontact?.customer?.twitterId || '',
              },
              attachments: [],
              conferenceMsg: false,
              summaryCardName: '',
            };

            dispatch(
              updateTwitterAgentReply({
                interactionId: activeInteractionID,
                replyMessage,
              })
            );
            //feature toggle condition for Enlighten Tab
            if (
              !showEnlightenTab &&
              userReplyChatData[indexVal].messageFrom === 'customer'
            ) {
              // dispatch(
              //   setContactSentiment({
              //     show: true,
              //     sentiment: sentimentType,
              //     cardName: userReplyChatData[indexVal].card,
              //   })
              // );

              dispatch(updateAppSpaceTab({ tab: AppSpace.SENTIMENT }));
            }
            indexVal = indexVal + 1;
          } else {
            dispatch(setJsonFileUploadStatus(false));
            dispatch(setIsChatEnded(true));
            fileUpload = false;
            clearInterval(loop);
          }
          document.getElementById('bodyContainer')?.scroll({
            top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
            behavior: 'smooth', //auto, smooth, initial, inherit
          });
        }, 3000);
      }
    }
  }, []);

  /**
   * Function to handle user reply
   * @example - handleIntent()
   * @returns
   */
  const handleIntent = (userReply: string) => {
    const intentTitle = intents[0]?.title ?? 'no matching intent title found';
    const intentText = intents[0]?.intent ?? 'no matching intent found';
    const tasks = intents[0]?.tasks ?? [];
    const outputPayload = {
      intent: intentText,
      title: intentTitle,
      tasks: [],
    };
    interface TaskData {
      order: any;
      text: any;
      choices?: { title: string; value: string }[];
    }
    const currentDate = new Date().toLocaleDateString();
    const modifiedTasks = tasks?.map((task: any) => {
      const taskData = {
        order: task.order,
        text: task.text.replace('%%date%%', currentDate),
      };
      if (task.buttons) {
        const choices = task.buttons.map((button: any) => {
          return { title: button.text, value: button.text };
        });
        return { ...taskData, choices };
      }
      return taskData;
    });

    // Assign modified tasks array to output payload
    outputPayload.tasks = modifiedTasks;

    const intentToBeDisplayed = `${translate('itLooksLike')} ${
      activecontact?.customer?.firstName
    } ${translate('wouldLikeTo')} ${intentTitle}.`;
    const filteredTasks = outputPayload?.tasks?.filter(
      (task: any) => task.choices
    );
    filteredTasks.forEach((task: any, index: any) => {
      task.changedOrder = index + 1;
    });
    const responseContent = {
      title: `${translate('taskAssist')}: ${intentTitle}`,
      intent: intentToBeDisplayed,
      intentSubTitle: intentTitle,
      tasks: filteredTasks,
    };
    if (userReply?.toLowerCase().includes(intentText?.toLowerCase())) {
      const response = {
        agentAssistSource: 'Illuminate',
        contactId: `${activecontact?.id}`,
        utcTimestamp: '2024-04-23T04:27:23.455584Z',
        acpAppElements: [
          {
            cardType: 'AdaptiveCard',
            contentType: 'intentAndAssistance',
            // eslint-disable-next-line no-useless-escape
            //"content":"{\n  \"icon\": \"PositiveSentimentIcon\",\n  \"sentiment\": \"Customer Sentiment is Positive\",\n  \"description\": \"The agent showed empathy, offered a solution, and ensured the well-being of the customer's child.\"\n}"
            content: JSON.stringify(responseContent),
            objectId: `e15d4e75-39fa-4f9d-85a1-daffe6d16a40_intent_${intentText}`,
          },
        ],
        type: null,
      } as ApiResponse;
      processApiResponse(response, dispatch);
      document.getElementById('bodyContainer')?.scroll({
        top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
        behavior: 'smooth', //auto, smooth, initial, inherit
      });
      return;
    }
  };

  /**
   * Function to handle user reply
   * @example - handleBehavioralGuidance()
   * @returns
   */
  const handleBehavioralGuidance = (userReply: string) => {
    for (const customReply of customReplies) {
      const statement = customReply.statement;
      const copilotReply = customReply.copilotReply;
      // eslint-disable-next-line @nice-cxone/ccf/required-tsdoc
      const generateResponseContent = (copilotReply: string) => {
        let title, icon;
        if (copilotReply.includes('Alert')) {
          title = translate('copilotAlert');
          icon =
            'data:image/png;base64,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';
        } else if (
          copilotReply.includes('Kudos') ||
          copilotReply.includes('Nice work!') ||
          copilotReply.includes('Great job') ||
          copilotReply.includes('Nicely done!')
        ) {
          title = translate('agentPraise');
          icon =
            'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik01LjAwMDAzIDcuNUM1LjAwMDAzIDguODI2MDggNS41MjY4MSAxMC4wOTc5IDYuNDY0NSAxMS4wMzU1QzcuNDAyMTggMTEuOTczMiA4LjY3Mzk1IDEyLjUgMTAgMTIuNUMxMS4zMjYxIDEyLjUgMTIuNTk3OSAxMS45NzMyIDEzLjUzNTYgMTEuMDM1NUMxNC40NzMyIDEwLjA5NzkgMTUgOC44MjYwOCAxNSA3LjVDMTUgNi4xNzM5MiAxNC40NzMyIDQuOTAyMTUgMTMuNTM1NiAzLjk2NDQ3QzEyLjU5NzkgMy4wMjY3OCAxMS4zMjYxIDIuNSAxMCAyLjVDOC42NzM5NSAyLjUgNy40MDIxOCAzLjAyNjc4IDYuNDY0NSAzLjk2NDQ3QzUuNTI2ODEgNC45MDIxNSA1LjAwMDAzIDYuMTczOTIgNS4wMDAwMyA3LjVaIiBzdHJva2U9IiMwMDg5NDAiIHN0cm9rZS13aWR0aD0iMS42NjY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8cGF0aCBkPSJNMTAgMTIuNUwxMi44MzM0IDE3LjQwODNMMTQuMTY1IDE0LjcxNDJMMTcuMTYzNCAxNC45MDc1TDE0LjMzIDEwTTUuNjY4MzYgMTBMMi44MzUwMiAxNC45MDgzTDUuODMzMzYgMTQuNzE0Mkw3LjE2NTAyIDE3LjQwNzVMOS45OTgzNiAxMi41IiBzdHJva2U9IiMwMDg5NDAiIHN0cm9rZS13aWR0aD0iMS42NjY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg==';
        } else if (copilotReply.includes('Enlighten AI Anomaly Detected')) {
          title = 'Enlighten AI Anomaly Detected';
          icon =
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFC0lEQVR4nO2Xa0wUVxTHp/aZpq80TfSDfaRJm9SkSY2tpntnGXdndu6d3SXycEvBYDSBAI2iJDSQQrIYsBiwVGpExKg8RIilEWcJadPEtbGwMyvaGoO1laiVaKs8Kuwui1GZ5mzcYYF9AUvrB07yT4A59/x/3Dvnzr0UtRiL8ZiHQlFPiAi9ESnPwbJrJZ4fBnVzHBMpH2pC7XkDtms0H4oI/f4jx70cEk6vXyrz/OhAVZUCgp/hb6HyoRbUhNpULEJE6BsbTYtWiloS7LlESFtfXt64t7VVAfVt335PMhrbQq4ITX9nQ6iailXYGeYpG0KnRZq2Tn/m4DjaaTR63E1NPjiQ5+hRxWk2uyW9Xjc934ZQiYhQ1/EVK56hYhkn16xZakPoRodGowsElwWh76/y8gk/nF9/79qlyIRc61m16ml/PoyFGlCLWoiwabWrOxhmmf93B88XXkxLc0+H8+tierpb5vlCFZBhlkGNeYOcRMjQyTDLw+VIDLNc4nnP3QMHgsKB7tbVKZDTpdO9Ga4WeIFn1IAdNF1go+lBG02Xtms0LwYFJKTzan7+vVBwfl3Nz78vE9IZrAbUBg/wAs+oAf3/lUjT9SJCt2w0nTkFTqfjz8bHuz3NzWHhfA3T3KycjY93OXQ6Y2ANqAm1wSPSaoWN9ri4lTaEtqnghDzrxLj/dmVlRDi/7uzeDQ1zy84wz6mACG2D2lSsQzIYyno3b57RGN9/WaEIRosiGD9RfiifCd+7aZNHwriMWsiAl13C2DNy8OAMAANZr6xeG+8TL1hmPB89dEiBsU6WfXvWxie02tdFhOpEhIpFmk7v0GrjTjDMW4F7GIRMyKlrhYX3gy0jiycBObI+6FJfLyh44MT4TGBN8AAv8ARvHwNCdcCkJtni4t4REcoSEdopItRko+kzIk1f79BoPvDndOv1iT3r1rnGjh0Lav5pcroKmJqUHjQHxp5LSHB16fUJ/rrgAV4+T4SaHjFkAVPUM9xjNj8vY3wbDgKhGiF3Y5YKmLsxO2Te4J49iozxgJ1hXqBiFRLPf/VbRoYnXKeWfpanApbm5IXt6kuZmWMyxlUxgZNZ9l0Z47HRw4fDmu7P/0IFrP28KGyu68gRmEWPg+Pemz8gIdKN4uIHkfa6b61lKmBbyc6Ie+OfRUUPnYLQM69DazfPbziXmBiyMbwBOl35tQr4U2Xod1VtmJYW5XxSkqub49LmBCcR8pKE8fBgdXVUX4vemloV8NL+0AeIQA3t3QuHiX/sDPPKrAFlQmov5+SMRWPkbW1VBhoaVcA7DY1RjQFdzs4elwWhdlZw3Rz3vkzImLu+Pmojb2urkrUhQ8lOy5jVGHdDA3ynPV0sG913GV5apyBc6N+x4+FsjLzzUH9JyYQT417Fag1655kSDo7LPJ+cHPKUvFD6xWJxg3f4peX5V2WeHxnet2/WBqcqqhSjKUUxmVIUe0XkLp6u4ZoauK6O9DDMa6Fnj+cbr2zd6p3LDJhMKWqTmM0pc5rFK1u2jDsIaQwK18WyHzkFweNujL4DvTEGhKur02Ry/8yyH09tDKt1iUzIpZtlZTOuj9HKXlHlgwQ42LTnWudmaemETMgfxy2WJyeX1mDI/TU11bXQjeCNRi0tyoXUVGgY9ZpByRgPzaUxvAskYJEwHpwEJGQIzmn/N5j3kYBlCqCD44wA6WBZ5XGQhPGgw2AQImzZi7EY1H8R/wLkltTvnR4pQgAAAABJRU5ErkJggg==';
        } else if (!copilotReply.includes('img')) {
          title = translate('copilotInsight');
          icon =
            'data:image/svg+xml;base64,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';
        }

        const responseContent = {
          title: title,
          icon: icon,
          copilotReply:
            (copilotReply && typeof copilotReply === 'string'
              ? copilotReply?.includes(':')
                ? copilotReply
                    ?.replace(/<\/?[^>]+(>|$)/g, '')
                    ?.split(':')
                    ?.slice(1)
                    ?.join(':')
                    ?.trim()
                : copilotReply?.replace(/<\/?[^>]+(>|$)/g, '')?.trim()
              : '') || '',
        };

        return responseContent;
      };
      if (
        userReply?.toLowerCase().includes(statement?.toLowerCase()) &&
        !copilotReply.includes('img')
      ) {
        const responseContent = generateResponseContent(copilotReply);
        const response = {
          agentAssistSource: 'Illuminate',
          contactId: `${activecontact?.id}`,
          utcTimestamp: new Date().toISOString(),
          acpAppElements: [
            {
              cardType: 'AdaptiveCard',
              contentType: 'behavioralGuidance',
              content: JSON.stringify(responseContent),
              objectId: `e15d4e75-39fa-4f9d-85a1-daffe6d16a40_behavioralGuidance_${statement}`,
            },
          ],
          type: null,
        } as ApiResponse;

        processApiResponse(response, dispatch);
        document.getElementById('bodyContainer')?.scroll({
          top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
          behavior: 'smooth', //auto, smooth, initial, inherit
        });
        return;
      }

      if (
        userReply.toLowerCase().includes(statement.toLowerCase()) &&
        copilotReply.includes('img')
      ) {
        let responseContent = {};
        // eslint-disable-next-line @nice-cxone/ccf/required-tsdoc, no-inner-declarations
        function extractImgAttributes(str: string) {
          const srcMatch = str.match(/src=['"]src=["']([^'"]+)['"]/);
          const src = srcMatch ? srcMatch[1].trim() : null;
          return { src };
        }
        const extractedValues = extractImgAttributes(copilotReply);
        responseContent = {
          kbAnswers: {
            title: `${statement}`,
            description: '',
          },
          kbLinks: [],
          kbImages: [
            {
              name: '',
              imageUrl: `${extractedValues.src}`,
            },
          ],
          kbProcessSteps: [],
        };

        if (statement.includes('What exactly is Croup?') === true) {
          responseContent = {
            kbAnswers: {
              title: '',
              description:
                'Croup is an infection of the upper airway that causes swelling and irritation around the voice box, windpipe, and bronchial tubes.\n\nThis swelling makes it harder to breathe and causes a cough that sounds like barking.\n\nCroup is usually caused by a viral infection, most commonly a parainfluenza virus, and is most common in children between 6 months and 3 years of age.\n\nMost cases of croup can be treated at home, but in rare cases, emergency medical care may be necessary.',
            },
            kbLinks: [
              {
                text: 'What is Croup?',
                link: 'https://omnicxonegamma-prod.cxoneexpert.ai/Knowledge_Content/Health_Conditions/What_is_Croup%3F',
              },
              {
                text: 'Diagnosis and Treatment for Croup',
                link: 'https://omnicxonegamma-prod.cxoneexpert.ai/Knowledge_Content/Health_Conditions/Diagnosis_and_Treatment_for_Croup',
              },
              {
                text: 'Causes and Prevention for Croup',
                link: 'https://omnicxonegamma-prod.cxoneexpert.ai/Knowledge_Content/Health_Conditions/Causes_and_Prevention_for_Croup',
              },
            ],
            kbImages: [
              {
                name: '',
                imageUrl: `${extractedValues.src}`,
              },
            ],
            kbProcessSteps: [
              {
                title:
                  'Identify the symptoms of croup such as a barking cough, hoarse voice, and difficulty breathing.',
                description:
                  'Ask the customer if their child is experiencing any of these symptoms.',
              },
              {
                title:
                  'Advise the customer to seek medical attention if they suspect their child has croup.',
                description:
                  'Inform the customer that croup can be diagnosed by a healthcare provider and that it is important to seek medical attention if they suspect their child has croup.',
              },
              {
                title: 'Recommend comfort measures to the customer.',
                description:
                  'Advise the customer to use a cool-mist humidifier, encourage their child to drink fluids, and keep their child calm and comfortable.',
              },
              {
                title:
                  'Inform the customer that medication may be prescribed to reduce swelling.',
                description:
                  'Let the customer know that medication such as corticosteroids may be prescribed by a healthcare provider to reduce swelling and improve breathing.',
              },
              {
                title:
                  'Encourage the customer to practice good hygiene and keep vaccinations up to date.',
                description:
                  'Remind the customer that practicing good hygiene and keeping vaccinations up to date can help prevent the spread of viral infections that can cause croup.',
              },
            ],
            utteranceId: '746cb641-1eeb-52b9-9d38-f0914ce74e1a',
          };
        }
        const response = {
          agentAssistSource: 'Illuminate',
          contactId: `${activecontact?.id}`,
          utcTimestamp: new Date().toISOString(),
          acpAppElements: [
            {
              cardType: 'AdaptiveCard',
              contentType: 'kbCombo',
              content: JSON.stringify(responseContent),
              objectId: `e15d4e75-39fa-4f9d-85a1-daffe6d16a40_kbCombo_${statement}`,
            },
          ],
          type: null,
        } as ApiResponse;

        processApiResponse(response, dispatch);
        document.getElementById('bodyContainer')?.scroll({
          top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
          behavior: 'smooth', //auto, smooth, initial, inherit
        });
        return;
      }
    }
  };

  /**
   * Function to handle user reply
   * @example - handleCustomerSentiment()
   * @returns
   */
  const handleCustomerSentiment = (userReply: string) => {
    for (const custSentiment of customerSentiment) {
      const sentimentString = custSentiment.sentiment;
      const statement = custSentiment.statement;
      const reason = custSentiment.reason;
      // eslint-disable-next-line @nice-cxone/ccf/required-tsdoc
      const generateResponseContent = (custSentiment: string) => {
        let sentiment, icon;
        if (sentimentString.includes('Neutral')) {
          sentiment = translate('adp_neutralPositiveSentiment');
          icon = 'NeutralPositiveSentimentIcon';
        } else if (sentimentString.includes('Positive')) {
          sentiment = translate('adp_positiveSentiment');
          icon = 'PositiveSentimentIcon';
        } else if (sentimentString.includes('Negative')) {
          sentiment = translate('adp_negativeSentiment');
          icon = 'NegativeSentimentIcon';
        }
        const responseContent = {
          sentiment: sentiment,
          icon: icon,
          description: reason,
        };
        return responseContent;
      };
      if (userReply?.toLowerCase().includes(statement?.toLowerCase())) {
        const responseContent = generateResponseContent(custSentiment);
        const response = {
          agentAssistSource: 'Illuminate',
          contactId: `${activecontact?.id}`,
          utcTimestamp: new Date().toISOString(),
          acpAppElements: [
            {
              cardType: 'AdaptiveCard',
              contentType: 'sentimentAndReason',
              content: JSON.stringify(responseContent),
              objectId: `e15d4e75-39fa-4f9d-85a1-daffe6d16a40_sentiment_${statement}`,
            },
          ],
          type: null,
        } as ApiResponse;

        processApiResponse(response, dispatch);
        document.getElementById('bodyContainer')?.scroll({
          top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
          behavior: 'smooth', //auto, smooth, initial, inherit
        });
        return;
      }
    }
  };

  useEffect(() => {
    if (activecontact?.copilotSource === 'Live LLM') {
      let indexVal = 0;
      let fileUpload =
        activecontact?.customerChatReply?.length &&
        activecontact?.customerChatReply?.length > 0
          ? false
          : true;
      let messageEntities: Array<{ message: string; fromEntity: string }> = [];

      if (activecontact?.channel === 'Email') {
        const replyMessage = {
          messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
          isOwn: true,
          isAgentReply: false,
          createdAt: 'Mon, July 28 12:02 PM (1 day ago)',
          messageContent: {
            payload: {
              text: userReplyChatData[0]?.messageFrom,
            },
          },
          authorUser: {
            emailAddress: activecontact?.receiverEmail,
            loginUsername: activecontact?.customer?.emailId,
            firstName: activecontact?.customer.firstName,
            surname: activecontact?.customer.lastName,
          },
          attachments: activecontact?.attachments || [],
          subject: activecontact?.emailSubject,
          isRead: false,
        };
        const customerRequestBody = {
          ...requestBody,
          messageBody: userReplyChatData[0]?.messageFrom || '<p></p>',
          participantId: 'patron',
          transcriptionEventId: uuidv5(
            userReplyChatData[0]?.messageFrom || '<p></p>',
            namespace
          ),
        };
        const apiCallPromises = [];
        // Initial API call
        apiCallPromises.push(
          callApi(
            API_BASE_URL + PROCESS_UTTERANCE,
            'POST',
            customerRequestBody,
            dispatch
          )
            .then((response: any) => {
              console.log(new Date().toISOString(), 'NBR, RT end');
              let ignoreNBR = false;
              const ignoreNBRText =
                "I've heard you're going to be offering free streaming?  Can you tell me more about that?";
              if (
                userReplyChatData[0]?.messageFrom
                  ?.toLowerCase()
                  .includes(ignoreNBRText.toLowerCase())
              ) {
                ignoreNBR = true;
              }
              processApiResponse(
                response.data,
                dispatch,
                'Digital',
                false,
                ignoreNBR
              );
            })
            .catch((error: any) => {
              console.error('Error:', error);
            })
        );
        Promise.allSettled(apiCallPromises).then(() => {
          dispatch(setIsRequestProcessing(false));
        });
        if (customerSentiment.length > 0) {
          handleCustomerSentiment(userReplyChatData[0]?.messageFrom);
        }

        dispatch(
          updateTwitterAgentReply({
            interactionId: activeInteractionID,
            replyMessage,
          })
        );
      }

      // eslint-disable-next-line @nice-cxone/ccf/required-tsdoc
      const handleKeyDown = (event: { key: string }) => {
        if (activecontact?.channel === 'Chat' && event.key === 'ArrowRight') {
          if (
            fileUpload &&
            isChatJsonFileUploaded &&
            indexVal < userReplyChatData.length
          ) {
            let userReply = '';
            if (
              userReplyChatData.length &&
              userReplyChatData[indexVal].messageFrom === 'customer'
            ) {
              userReply = userReplyChatData[indexVal].message[0];
              messageEntities = [
                ...messageEntities,
                {
                  message: userReplyChatData[indexVal].message[0],
                  fromEntity: 'patron',
                },
              ];

              if (intents.length > 0) {
                handleIntent(userReply);
              }
              if (customReplies.length > 0) {
                handleBehavioralGuidance(userReply);
              }
              if (customerSentiment.length > 0) {
                handleCustomerSentiment(userReply);
              }
            } else {
              userReply = userReplyChatData[indexVal].message[0];
              messageEntities = [
                ...messageEntities,
                {
                  message: userReplyChatData[indexVal].message[0],
                  fromEntity: 'patron',
                },
              ];
              if (intents.length > 0) {
                handleIntent(userReply);
              }
              if (customReplies.length > 0) {
                handleBehavioralGuidance(userReply);
              }
              if (customerSentiment.length > 0) {
                handleCustomerSentiment(userReply);
              }
            }
            const userReplyTranslateString = userReply
              .replace(/[^\w\s]/gi, '')
              .replace(/\s+/g, '_')
              .toLowerCase();
            const replyMessage = {
              messageId: new Date().toString(),
              postId:
                'chat_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
              isOwn: true,
              createdAt: formatMsgTime(locale),
              messageContent: {
                payload: {
                  text: translate(`${userReplyTranslateString}`) || userReply,
                },
              },
              reactionStatistics: {
                likes: 0,
              },
              authorUser: {
                firstName:
                  userReplyChatData[indexVal].messageFrom === 'bot'
                    ? 'Bot'
                    : userReplyChatData[indexVal].messageFrom === 'agent'
                    ? ''
                    : activecontact?.customer?.firstName,
                surname:
                  userReplyChatData[indexVal].messageFrom === 'bot'
                    ? 'Reply'
                    : userReplyChatData[indexVal].messageFrom === 'agent'
                    ? userReplyChatData[indexVal].agentName.split(' ')[0]
                    : activecontact?.customer?.lastName,
                emailAddress:
                  userReplyChatData[indexVal].messageFrom === 'bot'
                    ? 'bot@nice.com'
                    : userReplyChatData[indexVal].messageFrom === 'agent'
                    ? 'customer.service@delta.com'
                    : activecontact?.customer?.emailId,
                loginUsername: activecontact?.customer?.twitterId || '',
              },
              attachments: [],
              conferenceMsg: false,
              summaryCardName: userReplyChatData[indexVal].card,
            };

            dispatch(
              updateTwitterAgentReply({
                interactionId: activeInteractionID,
                replyMessage,
              })
            );

            if (
              userReplyChatData.length &&
              userReplyChatData[indexVal].messageFrom === 'customer'
            ) {
              userReply = userReplyChatData[indexVal].message[0];
              messageEntities = [
                ...messageEntities,
                {
                  message: userReplyChatData[indexVal].message[0],
                  fromEntity: 'patron',
                },
              ];

              const customerRequestBody = {
                ...requestBody,
                messageBody:
                  translate(`${userReplyTranslateString}`) || userReply,
                participantId: 'patron',
                transcriptionEventId: uuidv5(userReply, namespace),
              };
              const apiCallPromises = [];
              // Initial API call
              console.log(new Date().toISOString(), ' call start');
              apiCallPromises.push(
                callApi(
                  API_BASE_URL + PROCESS_UTTERANCE,
                  'POST',
                  customerRequestBody,
                  dispatch
                )
                  .then((response: any) => {
                    console.log(new Date().toISOString(), 'NBR, RT end');
                    let ignoreNBR = false;
                    const ignoreNBRText =
                      "I've heard you're going to be offering free streaming?  Can you tell me more about that?";
                    if (
                      userReply
                        .toLowerCase()
                        .includes(ignoreNBRText.toLowerCase())
                    ) {
                      ignoreNBR = true;
                    }
                    processApiResponse(
                      response.data,
                      dispatch,
                      'Digital',
                      false,
                      ignoreNBR
                    );
                  })
                  .catch((error: any) => {
                    console.error('Error:', error);
                  })
              );
              if (
                customerRequestBody.messageBody !== 'What exactly is Croup?'
              ) {
                apiCallPromises.push(
                  callApi(
                    API_BASE_URL + PROCESS_UTTERANCE,
                    'POST',
                    { ...customerRequestBody, getKbCombo: true },
                    dispatch
                  )
                    .then((response: any) => {
                      console.log(new Date().toISOString(), 'kb end');
                      const matchingConfidence =
                        activecontact?.confidence?.find((item: any) =>
                          userReply
                            .toLowerCase()
                            .includes(item.statement.toLowerCase())
                        );

                      const showGreenConfidenceDot = matchingConfidence
                        ? matchingConfidence.value === 'High'
                        : false;
                      callApi(
                        API_BASE_URL + PROCESS_UTTERANCE,
                        'POST',
                        { ...customerRequestBody, getProcessSteps: true },
                        dispatch
                      )
                        .then((response: any) => {
                          console.log(
                            new Date().toISOString(),
                            'process steps end'
                          );
                          processApiResponse(
                            response.data,
                            dispatch,
                            'Digital',
                            true,
                            false,
                            showGreenConfidenceDot
                          );
                        })
                        .catch((error: any) => {
                          console.error('Error:', error);
                        });
                      processApiResponse(
                        response.data,
                        dispatch,
                        'Digital',
                        false,
                        false,
                        showGreenConfidenceDot
                      );
                    })
                    .catch((error: any) => {
                      console.error('Error:', error);
                    })
                );
              }
              // salesOffers
              // salesOffers API call
              if (copilotConfigurations?.salesOffers ?? true) {
                apiCallPromises.push(
                  callApi(
                    API_BASE_URL + PROCESS_UTTERANCE,
                    'POST',
                    { ...customerRequestBody, getSalesOffers: true },
                    dispatch
                  )
                    .then((response: any) => {
                      console.log(new Date().toISOString(), 'sales offers end');
                      processApiResponse(response.data, dispatch);
                    })
                    .catch((error: any) => {
                      console.error('Error:', error);
                    })
                );
              }
              // compliance
              // compliance API call
              if (copilotConfigurations?.compliance ?? true) {
                apiCallPromises.push(
                  callApi(
                    API_BASE_URL + PROCESS_UTTERANCE,
                    'POST',
                    { ...customerRequestBody, getCompliance: true },
                    dispatch
                  )
                    .then((response: any) => {
                      console.log(new Date().toISOString(), 'compliance end');
                      processApiResponse(response.data, dispatch);
                    })
                    .catch((error: any) => {
                      console.error('Error:', error);
                    })
                );
              }
              // conversation Assistance
              // conversation Assistance API call
              apiCallPromises.push(
                callApi(
                  API_BASE_URL + PROCESS_UTTERANCE,
                  'POST',
                  { ...customerRequestBody, getConversationAssistance: true },
                  dispatch
                )
                  .then((response: any) => {
                    console.log(
                      new Date().toISOString(),
                      'conversation assistance end'
                    );
                    processApiResponse(response.data, dispatch);
                  })
                  .catch((error: any) => {
                    console.error('Error:', error);
                  })
              );
              // Process all API call promises
              Promise.allSettled(apiCallPromises).then(() => {
                dispatch(setIsRequestProcessing(false));
              });
            } else {
              userReply = userReplyChatData[indexVal].message[0];
              messageEntities = [
                ...messageEntities,
                {
                  message:
                    translate(`${userReplyTranslateString}`) || userReply,
                  fromEntity: 'agent',
                },
              ];

              const agentRequestBody = {
                ...requestBody,
                messageBody:
                  translate(`${userReplyTranslateString}`) || userReply,
                participantId: 'agent',
                transcriptionEventId: uuidv5(userReply, namespace),
              };
              callApi(
                API_BASE_URL + PROCESS_UTTERANCE,
                'POST',
                agentRequestBody,
                dispatch
              )
                .then((response: any) => {
                  //processApiResponse(response.data, dispatch);
                })
                .catch((error: any) => {
                  console.error('Error:', error);
                });
            }

            if (
              !showEnlightenTab &&
              userReplyChatData[indexVal].messageFrom === 'customer'
            ) {
              dispatch(
                setContactSentiment({
                  show: true,
                  sentiment: sentimentType,
                  cardName: userReplyChatData[indexVal].card,
                })
              );

              dispatch(updateAppSpaceTab({ tab: AppSpace.SENTIMENT }));
            }
            indexVal = indexVal + 1;
          } else {
            dispatch(setJsonFileUploadStatus(false));
            fileUpload = false;
          }
          document.getElementById('bodyContainer')?.scroll({
            top: document.getElementById('bodyContainer')?.scrollHeight,
            behavior: 'smooth',
          });
        }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
        document.removeEventListener('keydown', handleKeyDown);
      };
      // }
    }
    return undefined;
  }, [activecontact?.id]);

  useEffect(() => {
    if (isCopilotEmailResponseGenerated) {
      const contactId = `${activecontact?.id}`;
      const utcTimestamp = new Date().toISOString();
      const objectIdPrefix = 'e15d4e75-39fa-4f9d-85a1-daffe6d16a40_';
      const content = JSON.stringify({
        title: 'Reply Generated',
        description:
          'An email message has been generated and inserted into reply field for your review.',
      });
      const contentType = 'emailResponseGeneratedLive';
      const objectId = objectIdPrefix + contentType;
      const response = {
        agentAssistSource: 'Illuminate',
        contactId,
        utcTimestamp,
        acpAppElements: [
          {
            cardType: 'AdaptiveCard',
            contentType,
            content,
            objectId,
          },
        ],
        type: null,
      } as unknown as ApiResponse;
      setTimeout(() => {
        processApiResponse(response, dispatch);
      }, 2000);
    }
  }, [isCopilotEmailResponseGenerated]);

  useEffect(() => {
    if (isCopilotSourceLiveLLM && isRequestProcessing && activecontact?.channel === 'Email') {
      const contactId = `${activecontact?.id}`;
      const utcTimestamp = new Date().toISOString();
      const objectIdPrefix = 'e15d4e75-39fa-4f9d-85a1-daffe6d16a40_';
      const content = JSON.stringify({
        title: 'Email Response is generating...',
        description:
          'Wait for a few seconds, Copilot is working on your generated response.',
      });
      const contentType = 'emailResponseSuggestedLive';
      const objectId = objectIdPrefix + contentType;
      const response = {
        agentAssistSource: 'Illuminate',
        contactId,
        utcTimestamp,
        acpAppElements: [
          {
            cardType: 'AdaptiveCard',
            contentType,
            content,
            objectId,
          },
        ],
        type: null,
      } as unknown as ApiResponse;
      processApiResponse(response, dispatch);
    }
  }, [isRequestProcessing]);

  useEffect(() => {
    if (showTweetReplies) {
      setInteractionPostHeight('138%');
    } else if (currentInteactionType.facebook) {
      setInteractionPostHeight('0');
    }
  }, [showTweetReplies, activeInteractionID]);

  useEffect(() => {
    checkInteractionType();
  }, [activeInteractionID]);

  useEffect(() => {
    const rtigCards = [
      'Thank For Loyalty',
      'Be Empathetic',
      'Active Listening',
      'Mpower Client',
      'Speech Velocity',
      'Ask Questions',
      'Set Expectations',
      'No Interruptions',
      'Take Ownership',
    ];
    if (
      activecontact?.channel === 'Chat' &&
      activecontact?.customerChatReply.length > 0 &&
      agentReply[agentReply.length - 1]?.messageContent.payload.text !==
        activecontact?.customerChatReply &&
      activecontact?.customerChatReply !== 'kkkkk'
    ) {
      const userReply = activecontact?.customerChatReply;
      const sentimentCard = rtigCards[randomIntFromInterval(0, 8)];
      setTimeout(() => {
        const replyMessage = {
          messageId: new Date().toString(),
          postId:
            'chat_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
          isOwn: true,
          createdAt: formatMsgTime(locale),
          messageContent: {
            payload: {
              text: userReply,
            },
          },
          reactionStatistics: {
            likes: 0,
          },
          authorUser: {
            firstName: activecontact?.customer?.firstName,
            surname: activecontact?.customer?.lastName,
            emailAddress: activecontact?.customer?.emailId,
            loginUsername: activecontact?.customer?.twitterId || '',
          },
          attachments: [],
          conferenceMsg: false,
          semantics: sentimentType,
          summaryCardName: sentimentCard,
        };
        //feature toggle condition for Enlighten Tab
        if (!showEnlightenTab) {
          dispatch(
            setContactSentiment({
              show: true,
              sentiment: sentimentType,
              cardName: sentimentCard,
            })
          );

          dispatch(updateAppSpaceTab({ tab: AppSpace.SENTIMENT }));
        }

        dispatch(
          updateTwitterAgentReply({
            interactionId: activeInteractionID,
            replyMessage,
          })
        );
        document.getElementById('bodyContainer')?.scroll({
          top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
          behavior: 'smooth', //auto, smooth, initial, inherit
        });
      }, 5000);
    }
  }, [activecontact?.customerChatReply]);

  /**
   * Function to provide random integer value for percentage score
   * @param min - number
   * @param max - number
   * @example - randomIntFromInterval(10, 40)
   * @returns
   */
  function randomIntFromInterval(min: number, max: number) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  /**
   * Function to open quick reply
   * @param event -any
   * @example openQuickReply
   */
  const openQuickReply = (event: any) => {
    dispatch(updateAppSpaceTab({ tab: AppSpace.QUICK_REPLY }));
  };

  /**
   * Function to Call digital web chat card component
   * @param i -any
   * @param message- any
   * @example  callDigitalWebChatCard
   */
  const callDigitalWebChatCard = (
    i: any,
    selectedCallContact: any,
    interactionTab: any,
    isMiniCard: any,
    message: any
  ) => {
    return (
      <CcfChatBox
        i={i}
        isMiniCard={isMiniCard}
        replyCard={message}
        showHighligtedCard={
          message?.summaryCardName &&
          message.summaryCardName === suggestionCardHeader
            ? true
            : false
        }
      />
    );
  };

  /**
   * Function to Call digital email card component cc field
   * @param i -any
   * @param message- any
   * @param handleReplyEmailClick- any
   * @example  callDigitalEmailCard
   */
  const callDigitalEmailCard = (
    i: any,
    selectedCallContact: any,
    interactionTab: any,
    isMiniCard: any,
    message: any,
    emailListLength: number,
    hasReply?: any,
    handleDeleteClick?: any,
    emailSentDate?: any
  ) => {
    if (isCopilotSourceLiveLLM) {
      return (
        <CcfLiveDigitalEmailCard
        i={i}
        replyCard={message}
        emailListLength={emailListLength}
        emailDateData={emailDateData}
        emailSentDate={emailSentDate}
        subject={activecontact?.emailSubject}
        />
      );
    }
    return (
      <CcfDigitalEmailCard
        i={i}
        replyCard={message}
        emailListLength={emailListLength}
        emailDateData={emailDateData}
        emailSentDate={emailSentDate}
        subject={
          activecontact?.isElevated &&
          activecontact?.channel === DigitalChannelType.CHAT &&
          activecontact?.copilotAssist === 'Yes' &&
          activecontact?.copilotSource === 'JSON'
            ? '' + contactElevatedDetails.get('email')?.emailTemplate?.subject
            : activecontact?.channel === DigitalChannelType.EMAIL &&
              activecontact?.copilotAssist === 'Yes'
            ? translate('damagedLuggageClaim')
            : "RE: Where's my refund?"
        }
      />
    );
  };

  /**
   * Function to set height of interaction post
   * @param event -any
   * @example isEmail
   */
  const setInteractionPostHeight = (height: string) => {
    document.documentElement.style.setProperty(
      '--social-interaction-post-height',
      height
    );
  };

  /**
   * Function to set height of interaction post
   * @param event -any
   * @example isEmail
   */
  const formatMsgTime = (locale: string, timeZone?: string) => {
    const date = new Date();
    const resolvedTimeZone =
      timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
    const options: Intl.DateTimeFormatOptions = {
      timeZone: resolvedTimeZone,
      year: 'numeric', // Allowed values: 'numeric', '2-digit'
      month: 'short', // Allowed values: 'numeric', '2-digit', 'narrow', 'short', 'long'
      day: 'numeric', // Allowed values: 'numeric', '2-digit'
      hour: '2-digit', // Allowed values: 'numeric', '2-digit'
      minute: '2-digit', // Allowed values: 'numeric', '2-digit'
      second: '2-digit', // Allowed values: 'numeric', '2-digit'
    };

    return new Intl.DateTimeFormat(locale, options).format(date);
  };

  const postImagePath = currentInteactionType.twitter
    ? '/assets/Twitter_Post_SS.png'
    : currentInteactionType.facebook
    ? '/assets/Facebook_Post.png'
    : '/assets/Instagram_Post.png';

  /**
   * Returns the versions of original posts time.
   * @example - renderPostsTimeFrame()
   */
  const renderPostsTimeFrame = () => {
    let returnValue = '';
    switch (selectedCallContactChannel) {
      case InteractionTabType.INSTAGRAM:
        returnValue = '3 days ago';
        break;
      case InteractionTabType.FACEBOOK:
        returnValue = 'May 4th at 10.30 AM';
        break;
      default:
        returnValue =
          fomatToTimeString(new Date(originalTweetContent.createdAt)) +
          ' • ' +
          fomatToDateString(new Date(originalTweetContent.createdAt));
    }
    return returnValue;
  };

  /**
   * Returns the differnt set of social media icons.
   * @example - renderPostsIcons()
   */
  const renderPostsIcons = () => {
    let returnValue: any = '';
    switch (selectedCallContactChannel) {
      case InteractionTabType.INSTAGRAM:
        returnValue = (
          <>
            <span>
              <CcfTwitterFavoriteIcon viewBox="-4 -4 24 24" />
              {originalTweetContent.reactionStatistics.likes}
            </span>
            <span>
              <CcfTwitterCommentsIcon viewBox="-4 -4 24 24" />
              1092
            </span>
          </>
        );
        break;
      case InteractionTabType.FACEBOOK:
        returnValue = (
          <>
            <span>
              <CcfFacebookLikeIcon viewBox="-4 -4 24 24" />
            </span>
            <span>
              <CcfFacebookLoveIcon viewBox="-4 -4 24 24" />
            </span>
            <span>
              <CcfFacebookWowIcon viewBox="-4 -4 24 24" />
            </span>
            <span>243</span>
            <span>&nbsp;| 24 Comments</span>
            <span>11 Shares</span>
          </>
        );
        break;
      default:
        returnValue = (
          <>
            <span>
              <CcfTwitterCommentsIcon viewBox="-4 -4 24 24" />
              1092
            </span>
            <span>
              <CcfTwitterRetweetIcon viewBox="-4 -4 24 24" />
              642
            </span>
            <span>
              <CcfTwitterFavoriteIcon viewBox="-4 -4 24 24" />
              {originalTweetContent.reactionStatistics.likes}
            </span>
          </>
        );
    }
    return returnValue;
  };

  /**
   * Function to render original tweet
   * @example - renderOriginalTweet()
   * @returns
   */
  const renderOriginalTweet = () => (
    <div className={styles.originalTweetContainer}>
      <img alt="tweet" className={styles.tweetImage} src={postImagePath} />
      <div className={styles.originalTweetBody}>
        <div className={styles.originalTweetTitle}>
          {originalTweetContent.authorUser.firstName}
          {selectedCallContactChannel !== InteractionTabType.FACEBOOK ? (
            <CcfTwitterAuthBatchIcon viewBox="-5 -1 24 24" />
          ) : null}{' '}
        </div>
        <div className={styles.originalTweetSubtitle}>
          {renderPostsTimeFrame()}
        </div>
        <div>{originalTweetContent.messageContent.payload.text}</div>
        <div
          className={`
          ${styles.iconsContainer} 
          ${
            selectedCallContactChannel !== InteractionTabType.FACEBOOK
              ? classes.marginRight24
              : styles.facebookFooter
          }
        `}
        >
          {renderPostsIcons()}
        </div>
      </div>
    </div>
  );
  // const interactionTabDataForActiveContact = useSelector(getInteractionTabDataByID(props.selectedCallContact.id));
  // useEffect(() => {
  //   if(interactionTabDataForActiveContact === undefined) {
  //     dispatch(setInteractionTabData({[props.selectedCallContact.id]: props.data}))
  //   }
  // }, [props.selectedCallContact])

  useEffect(() => {
    if (quickReply && activecontact?.channel !== 'Email') {
      if (activecontact?.channel === 'Chat') {
        dispatchChatReplyMessage(quickReply);
        const interactionMSgCountCopy = Object.assign([], interactionMSgCount);
        const isInteractionPresent = interactionMSgCount.find(
          (contact: any) => contact.interactionID === activecontact?.id
        );
        interactionMSgCountCopy.push({
          interactionID: activecontact.id,
          userChatMsgCount: isInteractionPresent
            ? isInteractionPresent?.userChatMsgCount + 1
            : 0,
        });
        dispatch(setInteractionMsgCount(interactionMSgCountCopy));
        document.getElementById('bodyContainer')?.scroll({
          top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
          behavior: 'smooth', //auto, smooth, initial, inherit
        });
        dispatch(updateSentQReply(''));
      } else if (selectedCallContactChannel === 'sms') {
        dispatchChatReplyMessage(quickReply);
        dispatch(updateSentQReply(''));
      } else {
        dispatchChatReplyMessage(quickReply);
        dispatch(updateSentQReply(''));
      }
    }
  }, [quickReply]);

  useEffect(() => {
    if (
      showReplyBox &&
      activecontact?.channel !== 'Chat' &&
      selectedCallContactChannel !== 'sms'
    ) {
      textareaRef.current.focus();
    }
  }, [showReplyBox]);

  // useEffect(() => {
  //   initialReplyRender = false;
  // }, []);
  useEffect(() => {
    if (
      activecontact?.channel === 'Chat' ||
      selectedCallContactChannel === 'sms'
    ) {
      handleReplyClick();
    }
  }, [activecontact]);

  /**
   * Function to dispatch email reply message
   * @param message - string
   * @example dispatchEmailReplyMessage(quickReply)
   */
  const dispatchChatReplyMessage = (message?: string) => {
    if (!clickedAddNotes && !clickedCoBrowse) {
      const replyMessage = {
        messageId: new Date().toString(),
        postId:
          'chat_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        isOwn: true,
        createdAt: formatMsgTime(locale),
        messageContent: {
          payload: {
            text: message,
          },
        },
        reactionStatistics: {
          likes: 0,
        },
        authorUser: {
          firstName:
            activecontact?.copilotSource === 'Live LLM'
              ? agentName ?? 'Agent'
              : loginCredentialsArray[0].charAt(0).toUpperCase() +
                loginCredentialsArray[0].slice(1).toLowerCase(),
          surname:
            activecontact?.copilotSource === 'Live LLM'
              ? agentName === ''
                ? 'Nick'
                : ''
              : loginCredentialsArray[1].charAt(0).toUpperCase() +
                loginCredentialsArray[1].slice(1).toLowerCase(),
          emailAddress: 'customer.service@delta.com',
          loginUsername: '',
        },
        attachments: [],
        conferenceMsg: false,
      };
      // const replyMessage = {tweet: message, id: new Date().toString(), name: 'Agent'}
      dispatch(
        updateTwitterAgentReply({
          interactionId: activeInteractionID,
          replyMessage,
        })
      );
      const interactionMSgCountCopy = Object.assign([], interactionMSgCount);
      const isInteractionPresent = interactionMSgCount.find(
        (contact: any) => contact.interactionID === activecontact?.id
      );
      interactionMSgCountCopy.push({
        interactionID: activecontact ? activecontact?.id : '',
        userChatMsgCount: isInteractionPresent
          ? isInteractionPresent?.userChatMsgCount + 1
          : 0,
      });
      dispatch(setInteractionMsgCount(interactionMSgCountCopy));

      document.getElementById('bodyContainer')?.scroll({
        top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
        behavior: 'smooth', //auto, smooth, initial, inherit
      });
    } else if (clickedAddNotes) {
      const noteMessage = {
        messageId: 'Note_' + (agentReply.length - 1),
        postId:
          'chat_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341_Note',
        isOwn: true,
        isEditNote: true,
        createdAt: formatMsgTime(locale),
        messageContent: {
          type: 'NOTES',
          payload: {
            text: ' ',
          },
        },
        reactionStatistics: {
          likes: 0,
        },
        authorUser: {
          firstName:
            loginCredentialsArray[0].charAt(0).toUpperCase() +
            loginCredentialsArray[0].slice(1).toLowerCase(),
          surname:
            loginCredentialsArray[1].charAt(0).toUpperCase() +
            loginCredentialsArray[1].slice(1).toLowerCase(),
          emailAddress: 'customer.service@delta.com',
          loginUsername: '',
        },
        attachments: [],
        conferenceMsg: false,
      };
      // const replyMessage = {tweet: message, id: new Date().toString(), name: 'Agent'}
      dispatch(
        updateTwitterAgentReply({
          interactionId: activeInteractionID,
          replyMessage: noteMessage,
        })
      );
    } else if (clickedCoBrowse) {
      const coBrowseMessage = {
        messageId: 'CoBrowse_' + (agentReply.length - 1),
        postId:
          'chat_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341_CoBrowse',
        isOwn: true,
        createdAt: formatMsgTime(locale),
        messageContent: {
          type: 'COBROWSE',
          payload: {
            text: ' ',
          },
        },
        reactionStatistics: {
          likes: 0,
        },
        authorUser: {
          firstName:
            loginCredentialsArray[0].charAt(0).toUpperCase() +
            loginCredentialsArray[0].slice(1).toLowerCase(),
          surname:
            loginCredentialsArray[1].charAt(0).toUpperCase() +
            loginCredentialsArray[1].slice(1).toLowerCase(),
          emailAddress: 'customer.service@delta.com',
          loginUsername: '',
        },
        attachments: [],
        conferenceMsg: false,
      };
      // const replyMessage = {tweet: message, id: new Date().toString(), name: 'Agent'}
      dispatch(
        updateTwitterAgentReply({
          interactionId: activeInteractionID,
          replyMessage: coBrowseMessage,
        })
      );
    }
  };

  /**
   * Function to toggle original tweet view
   * @example - toggleOriginalTweetView()
   * @returns
   */
  const toggleOriginalTweetView = () =>
    setShowOriginalTweet(!showOriginalTweet);
  /**
   * Function to toggle tweet reply view
   * @example toggleTweetRepliesView()
   */
  const toggleTweetRepliesView = () => {
    setShowTweetReplies(!showTweetReplies);
    setShowReplyBox(false);
  };

  /**
   * Function to handle when user click on add notes button from text editor
   * @example
   */
  const handleAddNotesClick = () => {
    clickedAddNotes = true;
    dispatchChatReplyMessage();
    dispatch(setIsEditInlineNote(true));
  };

  /**
   * Function to handle when user click on Co browse button from text editor
   * @example
   */
  const coBrowsingHandler = () => {
    clickedCoBrowse = true;
    dispatchChatReplyMessage();
    // dispatch(setCoBrowsingSessionClosed(false));
  };
  /**
   * Function to handle send click
   * @example handleSendClick()
   */
  const handleSendClick = () => {
    if (textAreaValue.replace(/\s/g, '').length) {
      dispatchChatReplyMessage(textAreaValue);
      setInteractionPostHeight('138%');
      setTextAreaValue('');
      setShowReplyBox(false);
    }
  };

  /**
   * Function to handle send click
   * @example handleSendClick()
   */
  function renderContactWithBlankContactBody() {
    switch (selectedCallContactChannel) {
      case InteractionTabType.EMAIL:
        return callDigitalEmailCard(
          0,
          props.selectedCallContact,
          interactionTabs[activeInteractionID],
          false,
          {},
          agentReply.length,
          false
        );

      case InteractionTabType.SMS:
        return callDigitalWebChatCard(
          0,
          props.selectedCallContact,
          interactionTabs[activeInteractionID],
          false,
          {}
        );
      default:
        return;
    }
  }

  /**
   * Function to dispatch reply message
   * @param message - string
   * @example dispatchReplyMessage(quickReply)
   */
  const dispatchReplyMessage = (message: string) => {
    const replyMessage = {
      messageId: new Date().toString(),
      postId: 'tw_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabbb49',
      isOwn: true,
      createdAt: new Date().toISOString(),
      messageContent: {
        payload: {
          text: message,
        },
      },
      reactionStatistics: {
        likes: 0,
      },
      authorUser: {
        firstName: 'Agent',
        loginUsername: 'Agent',
      },
    };
    // const replyMessage = {tweet: message, id: new Date().toString(), name: 'Agent'}
    dispatch(
      updateTwitterAgentReply({
        interactionId: activeInteractionID,
        replyMessage,
      })
    );
    // setReplyMessages([...replyMessages, replyMessage]);
    if (currentInteactionType.facebook) {
      setShowTweetReplies(true);
    }
  };
  /**
   * Function to handle reply click
   * @example - handleReplyClick()
   */
  const handleReplyClick = () => {
    //initialReplyRender = true;
    if (props.selectedCallContact?.contactStatus !== 'new') {
      setShowReplyBox(true);
      setShowTweetReplies(false);
    }
  };

  /**
   * Function to handle delete click
   * @param id - string
   * @example - handleDeleteClick()
   */
  const handleDeleteClick = (id?: string) => {
    dispatch(
      updateTwitterAgentReply({
        interactionId: activeInteractionID,
        deleteTweetId: id,
      })
    );
  };
  // const agentReplyArray = interactionTabDataForActiveContact ? interactionTabDataForActiveContact[selectedCallContactChannel as string].agentReply : [];
  // const agentReplyArray = interactionTabs ? interactionTabs[activeInteractionID]?.agentReply : [];
  const showDividerClass = showTweetReplies ? styles.divider : '';
  // const {customerReplyContent, originalTweetId, otherReplies, originalTweetContent, originalTweetSender} = props.data[selectedCallContactChannel as string];
  return (
    <div
      id="agent_webChatContainer"
      className={
        activecontact?.channel?.includes('Chat')
          ? styles.chatContainer
          : activecontact?.channel === 'VideoCall'
          ? styles.videotwitterContainer
          : styles.twitterContainer
      }
    >
      <div
        id="bodyContainer"
        className={
          activecontact?.channel?.includes('Chat')
            ? styles.chatBodyContainer
            : activecontact?.channel === 'VideoCall'
            ? styles.videobodyContainer
            : styles.bodyContainer
        }
      >
        {showOriginalTweet ? renderOriginalTweet() : null}
        {selectedCallContactChannel !== InteractionTabType.EMAIL &&
          selectedCallContactChannel !== InteractionTabType.CHAT &&
          selectedCallContactChannel !== InteractionTabType.SMS &&
          selectedCallContactChannel !== InteractionTabType.VIDEOCALL &&
          selectedCallContactChannel !==
            InteractionTabType.REIMBURSEMENTCLAIM && (
            <div
              className={styles.viewTweetContainer}
              onClick={toggleOriginalTweetView}
            >
              <CcfSeeMoreIcon className={showOriginalTweet ? '' : 'upArrow'} />
              <CcfTypography
                className={styles.viewTweetLabel}
                translationKey={
                  showOriginalTweet
                    ? currentInteactionType.twitter
                      ? 'hideOriginalTweet'
                      : 'hideOriginalPost'
                    : currentInteactionType.twitter
                    ? 'viewOriginalTweet'
                    : 'viewOriginalPost'
                }
              />
            </div>
          )}
        {agentReply?.length > 0
          ? agentReply.map((message: any, i: number) => {
              const currentDate = new Date();
              const dd = currentDate.getDate() - 3;
              const mm = currentDate.getMonth();
              const yy = currentDate.getFullYear();
              const threeDaysAgoDate = new Date(yy, mm, dd);

              const date: any = isHistoryEmailContent
                ? message.isAgentReply
                  ? new Date()
                  : new Date(emailDateData?.correspondingDate)
                : message.isAgentReply
                ? new Date()
                : threeDaysAgoDate;
              let emailSentDate: any;
              let isMiniCard = true,
                hasReply = showTweetReplies,
                tweetId = props.selectedCallContact.customer.twitterId;
              classes.replyCard = '';

              if (currentInteactionType.facebook) {
                isMiniCard = !(i === agentReply.length - 1);
                hasReply = agentReply.length > 1 || showTweetReplies;
              } else if (i === 0) {
                isMiniCard = false;
                hasReply = agentReply.length > 1 || showTweetReplies;

                tweetId = originalTweetContent?.authorUser?.loginUsername || '';
              } else if (i === agentReply.length - 1) {
                classes.replyCard = styles.replyCard;
                scrollToEndOfTranscript = true;
              }
              switch (selectedCallContactChannel) {
                case InteractionTabType.EMAIL:
                  if (isCopilotSourceLiveLLM && i === 0) {
                    return null; // Skip intial static iteration in case of Live LLM
                  }
                  date.setDate(
                    message.isAgentReply ? date.getDate() : date.getDate() + i
                  );
                  emailSentDate = date.toLocaleString('en-us', {
                    weekday: 'short',
                    month: 'short',
                    day: '2-digit',
                    year: 'numeric',
                  });
                  return callDigitalEmailCard(
                    i,
                    props.selectedCallContact,
                    interactionTabs[activeInteractionID],
                    isMiniCard,
                    { ...message, tweetId }, //{message, tweetId: props.selectedCallContact.customer.twitterId, isLastCard: agentReply.length - 1 === i},
                    agentReply.length,
                    hasReply,
                    handleDeleteClick,
                    emailSentDate
                  );

                case InteractionTabType.FACEBOOK:
                  return CcfDigitalMessageCard(
                    props.selectedCallContact,
                    interactionTabs[activeInteractionID],
                    isMiniCard,
                    { ...message, tweetId }, //{message, tweetId: props.selectedCallContact.customer.twitterId, isLastCard: agentReply.length - 1 === i},
                    hasReply,
                    handleReplyClick,
                    handleDeleteClick,
                    classes
                  );

                case InteractionTabType.TWITTER:
                  return CcfDigitalMessageCard(
                    props.selectedCallContact,
                    interactionTabs[activeInteractionID],
                    isMiniCard,
                    { ...message, tweetId }, //{message, tweetId: props.selectedCallContact.customer.twitterId, isLastCard: agentReply.length - 1 === i},
                    hasReply,
                    handleReplyClick,
                    handleDeleteClick,
                    classes
                  );

                case InteractionTabType.INSTAGRAM:
                  return CcfDigitalMessageCard(
                    props.selectedCallContact,
                    interactionTabs[activeInteractionID],
                    isMiniCard,
                    { ...message, tweetId }, //{message, tweetId: props.selectedCallContact.customer.twitterId, isLastCard: agentReply.length - 1 === i},
                    hasReply,
                    handleReplyClick,
                    handleDeleteClick,
                    classes
                  );

                case InteractionTabType.CHAT:
                  //setChatShowReplyBox(true);
                  return callDigitalWebChatCard(
                    i,
                    props.selectedCallContact,
                    interactionTabs[activeInteractionID],
                    isMiniCard,
                    { ...message, tweetId } //{message, tweetId: props.selectedCallContact.customer.twitterId, isLastCard: agentReply.length - 1 === i},
                  );

                case InteractionTabType.SMS:
                  //setChatShowReplyBox(true);
                  return callDigitalWebChatCard(
                    i,
                    props.selectedCallContact,
                    interactionTabs[activeInteractionID],
                    isMiniCard,
                    { ...message, tweetId } //{message, tweetId: props.selectedCallContact.customer.twitterId, isLastCard: agentReply.length - 1 === i},
                  );
                case InteractionTabType.VIDEOCALL:
                  return <CcfCopilotVideoCall />;
                case InteractionTabType.REIMBURSEMENTCLAIM:
                  return <CcfCopilotReimbursementClaimForm />;
                default:
                  return;
              }
            })
          : renderContactWithBlankContactBody()}
        {selectedCallContactChannel !== InteractionTabType.EMAIL &&
          selectedCallContactChannel !== InteractionTabType.CHAT &&
          selectedCallContactChannel !== InteractionTabType.SMS &&
          selectedCallContactChannel !== InteractionTabType.VIDEOCALL &&
          selectedCallContactChannel !==
            InteractionTabType.REIMBURSEMENTCLAIM && (
            <div
              className={`${styles.viewTweetContainer} ${showDividerClass} ${styles.width100}`}
              onClick={toggleTweetRepliesView}
            >
              <CcfTypography
                className={styles.viewTweetLabel}
                translationKey={
                  showTweetReplies
                    ? currentInteactionType.twitter
                      ? 'hideRepliesTweet'
                      : 'hideRepliesPost'
                    : currentInteactionType.twitter
                    ? 'viewRepliesTweet'
                    : 'viewRepliesPost'
                }
              />
              <CcfSeeMoreIcon className={showTweetReplies ? 'upArrow' : ''} />
            </div>
          )}
        {showTweetReplies &&
          otherReplies.map((message: any) =>
            CcfDigitalMessageCard(
              props.selectedCallContact,
              interactionTabs[activeInteractionID],
              currentInteactionType.facebook ? false : true, //true,
              {
                ...message,
                tweetId: `${props.selectedCallContact.customer.twitterId} and ${originalTweetId}`,
              }, //{message, tweetId: `${props.selectedCallContact.customer.twitterId} and ${originalTweetId}`},
              showTweetReplies,
              handleReplyClick,
              handleDeleteClick,
              classes
            )
          )}
      </div>
      {((activecontact?.channel !== 'Email' &&
        activeInteractionType !== 'Email' &&
        showReplyBox) ||
        activeInteractionType === 'Chat' ||
        activeInteractionType === 'sms') && (
        <div id="agent_webChat_textEditor" className={styles.chatBoxContainer}>
          <div className={styles.chatBoxBody}>
            <div className={styles.title}>
              <div style={{ display: 'flex' }}>
                {activecontact?.channel !== 'Chat' ? (
                  <CcfTypography>
                    Replying to {props.selectedCallContact.customer.twitterId}
                  </CcfTypography>
                ) : (
                  <CcfTypography>
                    {`${translate('chatWith')} `}
                    {activecontact?.customer?.firstName?.split(' ')[0]}
                  </CcfTypography>
                )}
              </div>
              {activecontact?.channel === 'Chat' && (
                <div style={{ display: 'flex' }}>
                  <CcfTooltip
                    title={translate('inviteToCobrowsing')}
                    placement="top"
                    arrow
                    style={{ marginRight: '15px' }}
                  >
                    <div id="agent_webChat_cobrowsingIcon">
                      <CcfCoBrowseIcon
                        className={styles.coBrowseIcon}
                        onClick={coBrowsingHandler}
                      />
                    </div>
                  </CcfTooltip>
                  <CcfTooltip
                    title={translate('addNotes')}
                    placement="top"
                    arrow
                  >
                    <div>
                      <CcfAddNotesIcon
                        id="agent_webChat_addNotesIcon"
                        className={styles.addNotesIcon}
                        onClick={handleAddNotesClick}
                      />
                    </div>
                  </CcfTooltip>
                </div>
              )}
            </div>

            {activeInteractionType === DigitalChannelType.CHAT &&
              activecontact?.media === MediaType.DIGITAL &&
              activecontact?.copilotAssist === 'Yes' && (
                <div className={styles.suggestionCardBox}>
                  {activecontact?.channel !== 'Email' &&
                  activecontact?.copilotSource === 'JSON' ? (
                    <CcfCopilotChatSuggestionCard />
                  ) : (
                    <CcfTextEditor getTextCB={dispatchChatReplyMessage} />
                  )}
                </div>
              )}

            {(activeInteractionType === 'Chat' &&
              (activecontact?.media === MediaType.VOICE ||
                activecontact?.copilotAssist === 'No')) ||
            selectedCallContactChannel === 'sms' ||
            activeInteractionType === 'sms' ? (
              <div className={styles.chatBox}>
                <CcfTextEditor getTextCB={dispatchChatReplyMessage} />
              </div>
            ) : (
              activeInteractionType !== 'Email' &&
              activecontact?.channel !== 'Chat' &&
              activecontact?.channel !== 'Email' && (
                <div className={styles.chatBoxTextarea}>
                  <Avatar
                    alt="Twitter Reply"
                    src="https://mui.com/static/images/avatar/7.jpg"
                  />
                  <textarea
                    rows={2}
                    value={textAreaValue}
                    ref={textareaRef}
                    id="interactionWorkaspace_textEditor"
                    onChange={(e) => setTextAreaValue(e.target.value)}
                  ></textarea>
                </div>
              )
            )}
          </div>
          {activecontact?.channel !== 'Chat' &&
            selectedCallContactChannel !== 'sms' &&
            activeInteractionType !== 'Chat' &&
            activeInteractionType !== 'sms' && (
              <div className={styles.chatBoxFooter}>
                <div className={styles.chatBoxFooterIcons}>
                  <CcfTwitterInsertGifIcon
                    stroke="#657786"
                    viewBox="-2 -2 24 24"
                  />
                  <CcfTwitterInsertEmojiIcon viewBox="-2 -2 24 24" />
                  <CcfTwitterInsertPicIcon viewBox="-2 -2 24 24" />
                </div>
                <div className={styles.sendButtonContainer}>
                  <CcfButton
                    className={styles.buttonClass}
                    onClick={openQuickReply}
                    id="interactionWorkaspace_editor_quickReplyButton"
                  >
                    <CcfFlashIcon />
                    Replies
                  </CcfButton>
                  <CcfButton
                    className={styles.buttonClass}
                    onClick={(e) => {
                      setShowReplyBox(false);
                    }}
                    id="interactionWorkaspace_editor_cancelButton"
                  >
                    Cancel
                  </CcfButton>
                  <CcfButton
                    primary
                    onClick={handleSendClick}
                    variant="contained"
                    color="primary"
                    id="interactionWorkaspace_editor_sendReplyButton"
                    className={styles.sendButton}
                    disabled={!textAreaValue.replace(/\s/g, '').length}
                  >
                    <Send />
                  </CcfButton>
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
}

export default CcfInteractionBody;
